import React from 'react';
import styled from 'styled-components';
import {StyledProps, mediaQueries} from '../modules/common';

interface Props extends StyledProps {
    children: React.ReactNode;
}

const UnstyledList = (props: Props): JSX.Element => {
    const {className, children} = props;
    const listItems = React.Children.map(children, (item) => <li>{item}</li>);
    return <ul className={className}>{listItems}</ul>;
};

const List = styled(UnstyledList)`
    margin: 8px 0;
    padding-left: 40px;
    ${mediaQueries.lessThan('small')`
        font-size: ${(props): string =>
            `${props.theme.fontSizes.small}${props.theme.unitsOfMeasure.px}`}
    `};
`;

export default List;
